import {
  FormContainerWithHeader,
  FormTextField,
} from '../../../../presentation';

import { getFieldProps } from '@converge/data';
import { useTranslation } from 'react-i18next';

interface IProps {
  isReadonly?: boolean;
}

export const UnderwritingOverviewUnderwritingProsCons = (props: IProps) => {
  const { t } = useTranslation();

  return (
    <FormContainerWithHeader
      title={t(
        'underwriting.detail.content.sections.prosCons.title',
        'Pros and Cons'
      )}
    >
      <FormTextField
        {...getFieldProps('prosAndCons', false, '')}
        containerWidth={12}
        isRichText
      />
    </FormContainerWithHeader>
  );
};
